import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { makeStyles } from '@material-ui/core/styles';
import { isUndefined } from 'lodash';

import { ROUTES } from '../../../constants/routes';
import { stripeService } from '../../../services';
import { userActions } from '../../../redux/actions';

const useStyles = makeStyles((theme) => ({
  toolbarElement: {
    position: 'fixed !important',
    width: '100% !important',
    display: 'flex !important',
    justifyContent: 'flex-end !important',
    zIndex: '1 !important'
  }
}));

export default function ButtonAppBar() {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();

  const { user } = useSelector(state => state.userAuthentication);

  const [portalSessionUrl, setPortalSessionUrl] = useState(undefined);

  const routeChangeSignup = () => {
    history.push(ROUTES.COMMERCIALSUBSCRIPTIONSIGNUP);
  }

  const routeChangeLogin = () => {
    history.push(ROUTES.COMMERCIALSUBSCRIPTIONLOGIN);
  }

  const handleUserLogout = (event) => {
    event.preventDefault();

    if (user) {
      dispatch(userActions.logout(user.refresh));
    }
  }

  const createPortalSession = useCallback(async (value) => {
    const customerId = 'cus_KR94GycLd5mJBG';

    const payload = {
      customer: customerId
    }

    const res = await stripeService.createPortalSession(payload);

    if (!isUndefined(res)) {
      const url = JSON.parse(res).url;
      setPortalSessionUrl(url);
    }
  }, []);

  useEffect(() => {
    createPortalSession();
  }, [createPortalSession]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar className={classes.toolbarElement}>
          {user ? (
            <>
              <a style={{ textDecoration: 'none', color: '#FFF' }} href={portalSessionUrl ? portalSessionUrl : "#"}>
                <Button color="inherit">Manage Billing</Button>
              </a>
              <Button color="inherit" onClick={handleUserLogout}>Logout</Button>
            </>
          ) : (
            <>
              <Button color="inherit" onClick={routeChangeSignup}>Signup</Button>
              <Button color="inherit" onClick={routeChangeLogin}>Login</Button>
            </>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}